import { Cookies } from 'react-cookie';

const cookies = new Cookies();

export { cookies };
